{
  "version": 1,
  "asset_id": "a10b0d2a-88d9-4161-a9a7-e1a3c08d6642",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a10b0d2a-88d9-4161-a9a7-e1a3c08d6642/hiatal-type-3-es-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a10b0d2a-88d9-4161-a9a7-e1a3c08d6642/hiatal-type-3-es-v3-800.webp",
  "original_filename": "hiatal-type-3-es-v3-800.webp",
  "size": 101248,
  "content_type": "image/webp",
  "created_at": "2026-10-28T22:48:22Z"
}
